export const MIN_AUDIO_OFFSET_MS = -500;
export const MAX_AUDIO_OFFSET_MS = 500;

export type AudioAlignmentPlan = {
  offsetMs: number;
  seekSeconds: number;
  delayMs: number;
};

export function clampAudioOffsetMs(value: number): number {
  if (!Number.isFinite(value)) return 0;
  return Math.max(MIN_AUDIO_OFFSET_MS, Math.min(MAX_AUDIO_OFFSET_MS, Math.round(value)));
}

export function planAudioAlignment(value: number): AudioAlignmentPlan {
  const offsetMs = clampAudioOffsetMs(value);
  return {
    offsetMs,
    seekSeconds: offsetMs < 0 ? -offsetMs / 1000 : 0,
    delayMs: offsetMs > 0 ? offsetMs : 0,
  };
}

export function correctedAudioOriginMs(playPerformanceMs: number, currentTimeSeconds: number): number {
  return playPerformanceMs - Math.max(0, currentTimeSeconds) * 1000;
}
